import { render, staticRenderFns } from "./BetBalance.vue?vue&type=template&id=1036ad10"
import script from "./BetBalance.vue?vue&type=script&lang=js"
export * from "./BetBalance.vue?vue&type=script&lang=js"
import style0 from "./BetBalance.vue?vue&type=style&index=0&id=1036ad10&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports